import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { dataImportSchema, dataImportListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/dataImports/actions';
import { DataImportsActionTypes as types } from 'app/ducks/dataImports/types';

function* createDataImportSaga(action): any {
  yield put(sagaActions.createDataImportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).dataImports.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, dataImportSchema);

    yield put(sagaActions.createDataImportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createDataImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateDataImportSaga(action): any {
  yield put(sagaActions.updateDataImportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).dataImports.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, dataImportSchema);

    yield put(sagaActions.updateDataImportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateDataImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getDataImportSaga(action): any {
  yield put(sagaActions.getDataImportPending());
  const [error, response] = yield (yield TeammoApi(yield select())).dataImports.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, dataImportSchema);
    yield put(sagaActions.getDataImportSuccess(normalizedResponse));
    return normalizedResponse.entities.dataImports[normalizedResponse.result];
  }
  yield put(
    handleError(
      error,
      sagaActions.getDataImportFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllDataImportsSaga(action): any {
  yield put(
    sagaActions.getAllDataImportsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.dataImports.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(yield select())).dataImports.list(
    action.payload.organisationId,
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, dataImportListSchema);

    yield put(
      sagaActions.getAllDataImportsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllDataImportsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createDataImportSagaWatcher(): any {
  yield takeLatest(types.CREATE_DATA_IMPORT_REQUESTED, createDataImportSaga);
}

function* updateDataImportSagaWatcher(): any {
  yield takeLatest(types.UPDATE_DATA_IMPORT_REQUESTED, updateDataImportSaga);
}

function* getDataImportSagaWatcher(): any {
  yield takeEvery(types.GET_DATA_IMPORT_REQUESTED, getDataImportSaga);
}

function* getAllDataImportsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_DATA_IMPORTS_REQUESTED,
    getAllDataImportsSaga,
  );
}

export default function* root(): any {
  yield all([
    createDataImportSagaWatcher(),
    updateDataImportSagaWatcher(),
    getDataImportSagaWatcher(),
    getAllDataImportsSagaWatcher(),
  ]);
}
